import { forwardRef, FunctionComponent, InputHTMLAttributes, PropsWithChildren, useState } from 'react';
import { InputBaseComponentProps, TextField, IconButton } from '@material-ui/core';
import InputMask from 'react-input-mask';
import { PasswordShowIcon, PasswordHideIcon } from 'Components';
import { noAutoFillProps } from 'Utils';

type TextMaskCustomProps = {
  mask: string;
  label: string;
  passwordInput?: boolean;
  innerRef?: ((instance: HTMLDivElement | null) => void) | React.RefObject<HTMLDivElement> | null | undefined;
} & InputHTMLAttributes<HTMLInputElement> &
  PropsWithChildren<InputBaseComponentProps>;

const MaskInput = forwardRef<any, any>(function MaskInput({ mask, maskPlaceholder, ...props }, ref) {
  return (
    // @ts-ignore - react-input-mask type compatibility issue with React 18
    <InputMask mask={mask} maskPlaceholder={maskPlaceholder ?? ''} ref={ref} {...props} />
  );
});

const MaskedTextField: FunctionComponent<TextMaskCustomProps> = (props) => {
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const ShowHidePasswordIcon = showPassword ? PasswordHideIcon : PasswordShowIcon;

  const { mask = '', label = '', inputProps, passwordInput, innerRef, inputMode, ...otherProps } = props;

  return (
    <TextField
      label={label}
      variant="filled"
      fullWidth
      InputLabelProps={{
      shrink: !!(otherProps as any).value || undefined,
      }}
      inputProps={{
        inputMode: inputMode ?? 'numeric',
        mask,
        maskPlaceholder: '',
        'aria-label': typeof label === 'string' && label ? label : (otherProps as any).name,
        ...inputProps,
        ...(passwordInput && noAutoFillProps),
      }}
      InputProps={{
        inputComponent: MaskInput,
        ...(passwordInput && {
          endAdornment: (
            <IconButton
              aria-label={showPassword ? 'Şifreyi gizle' : 'Şifreyi göster'}
              onClick={() => setShowPassword(!showPassword)}
              size="small"
              edge="end"
            >
              <ShowHidePasswordIcon />
            </IconButton>
          ),
        }),
      }}
      ref={innerRef}
      {...(otherProps as any)}
      {...(passwordInput && {
        type: showPassword ? 'text' : 'password',
      })}
    />
  );
};

export default MaskedTextField;
